import { render, staticRenderFns } from "./reminder-setting.vue?vue&type=template&id=0f5b2856"
import script from "./reminder-setting.vue?vue&type=script&lang=js"
export * from "./reminder-setting.vue?vue&type=script&lang=js"
import style0 from "./reminder-setting.vue?vue&type=style&index=0&id=0f5b2856&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f5b2856')) {
      api.createRecord('0f5b2856', component.options)
    } else {
      api.reload('0f5b2856', component.options)
    }
    module.hot.accept("./reminder-setting.vue?vue&type=template&id=0f5b2856", function () {
      api.rerender('0f5b2856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Distribution/reminder-setting.vue"
export default component.exports